const { analyticsEventCenter } = require('../analytics/events');

/* eslint-disable-next-line valid-jsdoc */
/**
 * Get the AnalyticsEventCenter outside the datalayer component. This is the
 * only way to access to it without duplicating requires.
 * @returns {analyticsEventCenter}
 */
function getAnalyticsEventCenter() {
  const { bylAnalytics = false } = window;
  if (!bylAnalytics) {
    throw new Error('Public analytics method are not available yet');
  }
  /** @type {analyticsEventCenter} */
  return analyticsEventCenter;
}

module.exports = getAnalyticsEventCenter;
